export default __webpack_public_path__ + "static/media/screen_livechat_16.96a0521a.png";